import React, {forwardRef, useEffect, useRef} from 'react';
import clsx from 'clsx';

import styles from './styles/input.module.scss';

type Props = {
  type?: string;
  name?: string;
  className?: string;
  label: string;
  isFocused?: boolean;
  isRequired?: boolean;
  isDisabled?: boolean;
};

const Input = forwardRef<HTMLInputElement, Props>(
  (
    {
      type = 'text',
      name,
      className,
      label,
      isFocused,
      isRequired,
      isDisabled,
      ...props
    },
    ref
  ) => {
    const localRef = useRef(null);
    const inputRef = ref ?? localRef;

    const inputProps = {
      ref: inputRef,
      type,
      name,
      'aria-label': label,
      placeholder: label,
      required: isRequired,
      disabled: isDisabled,
      ...props
    };

    useEffect(() => {
      if (isFocused) {
        (inputRef as any).current.focus({preventScroll: true});
      }
    }, []);

    return label ? (
      <label className={styles.label}>
        <input className={clsx(styles.input, className)} {...inputProps} />
        <span className={styles.labelText}>{label}</span>
      </label>
    ) : (
      <input
        className={clsx(styles.input, styles.input__standalone, className)}
        {...inputProps}
      />
    );
  }
);

export default Input;
